import {Injectable} from '@angular/core';
import {RestClientService} from './rest-client/rest-client.service';
import {Observable} from 'rxjs';
import {CustomAuthService} from './auth';

@Injectable({
  providedIn: 'root'
})
export class UserActionLogService {

  constructor(private restClient: RestClientService, private authService: CustomAuthService) {
  }

  public trackCampaignView(campaignId: string): Observable<void> {
    const userId = this.authService.getCurrentUser()!.id;
    return this.restClient.put<void>(`/users/${userId}/actions-log/campaign/${campaignId}/view`, null);
  }
}
